import { VoidCallback } from '@deqo/foundation';
import { Placement } from '@popperjs/core';
import React, { ComponentType, useCallback, useState } from 'react';
import { usePopper } from 'react-popper';
import { usePrompt } from '../../../ui';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { PopperInner, PopperMount } from './PopperElements';

export type PopperButtonProps = {
    active: boolean,
    onClick: VoidCallback,
};

export type PopperContentProps = {
    onClose: VoidCallback,
};

export type PopperProps = {
    button: ComponentType<PopperButtonProps>,
    content: ComponentType<PopperContentProps>,
    placement?: Placement,
    inner?: { direction?: string, offset?: string },
    grow?: boolean,
};

export type PopperWithCustomOpenProps = PopperProps & { open: boolean, setOpen: (value: boolean) => void };

export const PopperWithCustomOpen = ({ open, setOpen, button: Button, content: Content, placement, inner, grow }: PopperWithCustomOpenProps) => {

    const [refElmt, setRefElmt] = useState(null);
    const [popElmt, setPopElmt] = useState(null);

    const { styles, attributes } = usePopper(refElmt, popElmt, { placement });

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: () => setOpen(false),
    });

    const onToggle = useCallback(() => setOpen(!open), [open, setOpen]);

    return <Flexer ref={promptRef} flex="row" grow={grow}>
        <Flexer ref={setRefElmt}>
            <Button active={open} onClick={onToggle} />
        </Flexer>
        {open && <PopperMount ref={setPopElmt} style={styles.popper} {...attributes.popper}>
            <PopperInner {...(inner || {})}>
                <Content onClose={() => setOpen(false)} />
            </PopperInner>
        </PopperMount>}
    </Flexer>;
};

export const Popper = (props: PopperProps) => {
    const [open, setOpen] = useState(false);
    return <PopperWithCustomOpen {...props} open={open} setOpen={setOpen} />;
};
